import { render } from "./Phone.vue?vue&type=template&id=ce44debc"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Phone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ce44debc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ce44debc', __exports__)) {
    api.reload('ce44debc', __exports__)
  }
  
  module.hot.accept("./Phone.vue?vue&type=template&id=ce44debc", () => {
    api.rerender('ce44debc', render)
  })

}


export default __exports__